var _title, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoBitbucket = function SvgLogoBitbucket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Bitbucket")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M8.087 9a1.08 1.08 0 0 0-.827.371 1.076 1.076 0 0 0-.22.407c-.042.15-.051.308-.026.462l4.559 27.547A1.453 1.453 0 0 0 13 39h21.85a1.068 1.068 0 0 0 1.073-.898l4.56-27.85a1.06 1.06 0 0 0-.247-.87 1.07 1.07 0 0 0-.826-.37L8.087 9ZM27.26 28.904h-6.972L18.4 19.07h10.55l-1.69 9.834Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M39.019 19.08H28.95l-1.69 9.835H20.29l-8.233 9.732c.26.225.593.35.938.353H34.85a1.068 1.068 0 0 0 1.073-.898l3.095-19.022Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 41.346,
    x2: 24.753,
    y1: 21.833,
    y2: 34.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
};
export default SvgLogoBitbucket;